/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "App";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Soft UI Dashboard PRO React themes
import theme from "assets/theme";

// Soft UI Context Provider
import { SoftUIControllerProvider } from "context";
import { NotificationProvider } from "context/notification";
import { UserProvider } from "context/user";
import { AgencyProvider } from "context/agency";
import { loadConfig } from "config";
import env from "config/env";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

async function bootstrap() {
  const config = await loadConfig();
  Object.assign(env, config);

  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    window.self === window.top && !window.location.pathname.includes("/integrations/stripe") ? <></> : (
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <SoftUIControllerProvider>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              {/* Must wrap UserProvider/AgencyProvider (not just <App/>,
                  where it used to live) - they call useAppServices() during
                  their own mount-time logic, which depends on
                  useNotifcation(), and context only flows to descendants, so
                  a provider nested inside <App/> could never be seen by its
                  own ancestors. Not actively crashing today (nothing in
                  UserProvider/AgencyProvider currently passes toaster: true),
                  but the same landmine super-admin hit. */}
              <NotificationProvider>
                <UserProvider>
                  <AgencyProvider>
                    <App />
                  </AgencyProvider>
                </UserProvider>
              </NotificationProvider>
            </ThemeProvider>
          </SoftUIControllerProvider>
        </BrowserRouter>
      </QueryClientProvider>

    )
  )

}

bootstrap();
